export default class BlockGallerySliderSimple {
	static init() {

		let blocks = document.querySelectorAll('.block-gallery-slider-simple');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.block-gallery-swiper-simple');
			const prev = block.querySelector(".gallery-button-prev");
			const next = block.querySelector(".gallery-button-next");
			const navigation = block.querySelector('.swiper-navigation');
			new Swiper(swiper, {
				slidesPerView: 1,
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				pagination: {
					el: navigation,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});
		});

	}
}
